webpackJsonp([134],{

/***/ 1165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssignedReviewTable_vue__ = __webpack_require__(2836);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44269044_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssignedReviewTable_vue__ = __webpack_require__(4799);
function injectStyle (ssrContext) {
  __webpack_require__(4797)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44269044"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssignedReviewTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44269044_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssignedReviewTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TaskDescButton'
});

/***/ }),

/***/ 1555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDescButton_vue__ = __webpack_require__(1514);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbc218e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDescButton_vue__ = __webpack_require__(1558);
function injectStyle (ssrContext) {
  __webpack_require__(1556)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbc218e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDescButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbc218e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDescButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1556:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1557);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("39328c12", content, true, {});

/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TaskDescButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticStyle:{"position":"absolute","right":"200px","bottom":"18px","color":"red"},attrs:{"href":"https://slicejobs-tech.feishu.cn/wiki/IFSEwU6zhi3fetk53uScDxFPnwh","target":"_blank"}},[_vm._v("查看任务&工单&证据归档说明\n  ")]),_vm._v(" "),_c('a',{staticStyle:{"position":"absolute","right":"10px","bottom":"18px"},attrs:{"href":"http://img-cn-shanghai.aliyuncs.com/taskdesc/190603/50/ad816a4cf26d21609f15540fa701c174.png","target":"_blank"}},[_vm._v("查看任务&工单&零工说明\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    batchid: String
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  }), {
    search: function search() {
      return this.searchValue;
    }
  }),
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.$confirm('是否按批次通过工单?', '操作确认', {}).then(function () {
        _this.passByBatchId();
      }).catch(function (action) {
        console.log('取消按批次批量通过操作');
      });
    },
    passByBatchId: function passByBatchId() {
      var _this2 = this;

      return request.alert('onBatchSuccceed', { batchid: this.batchid }).then(function (res) {
        _this2.$message({
          showClose: true,
          message: '按批次批量通过成功,请前往批量任务查看',
          type: 'success'
        });
      });
    }
  }
});

/***/ }),

/***/ 1602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    batchid: String
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  }), {
    search: function search() {
      return this.searchValue;
    }
  }),
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.$confirm('是否确认按批次（已抢单、进行中）收回?', '操作确认', {}).then(function () {
        _this.onRequest();
      }).catch(function (action) {
        console.log('取消按批次收回工单操作');
      });
    },
    onRequest: function onRequest() {
      var _this2 = this;

      return request.alert('onBatchWithdraw', { batchid: this.batchid }).then(function (res) {
        _this2.$message({
          showClose: true,
          message: '按批次收回成功,请前往批量任务查看',
          type: 'success'
        });
      });
    }
  }
});

/***/ }),

/***/ 1603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__order_rules__ = __webpack_require__(1783);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    batchid: String
  },
  data: function data() {
    return {
      batchRules: __WEBPACK_IMPORTED_MODULE_2__order_rules__["a" /* batchRules */],
      loading: false,
      dialogFormVisible: false,
      innerVisible: false,
      form: {
        file: null,
        starttime: null,
        order_id: null,
        batch_id: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  })),
  watch: {
    dialogFormVisible: function dialogFormVisible(value) {
      if (!value) {
        this.$refs.uploadThumb.clearFiles();
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      }
    }
  },
  methods: {
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('选择文件大小不能超过 2MB!');
      }
      return isLt2M;
    },
    uploadRequest: function uploadRequest(obj) {
      this.form.file = obj.file;
    },
    onOpenInner: function onOpenInner() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this.innerVisible = true;
        } else {
          _this.$message.error('提交内容填写不正确！');
        }
      });
    },
    onDetection: function onDetection() {
      var _this2 = this;

      var data = new FormData();
      data.append('file', this.form.file);
      data.append('starttime', this.form.starttime);
      data.append('batch_id', this.batchid);

      return request.common('onBatchCheckDetection', data).then(function (res) {
        _this2.$message('检测成功');
        _this2.dialogFormVisible = false;
        _this2.innerVisible = false;
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      var data = new FormData();
      data.append('file', this.form.file);
      data.append('starttime', this.form.starttime);
      data.append('order_id', this.form.orderid);
      data.append('batch_id', this.batchid);

      return request.common('onBatchCheckDetection', data).then(function (res) {
        _this3.$message('请前往批量任务中确认');
        _this3.dialogFormVisible = false;
        _this3.innerVisible = false;
      });
    }
  }
});

/***/ }),

/***/ 1692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    visible: Boolean,
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      id: 0,
      form: {
        allowance: ''
      }
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ allowance: _this.form.allowance }, _this.info);
                _context.next = 4;
                return request.alert('executiveAllowanceApply', params).then(function (res) {
                  _this.$message.success('执行补贴申请发送成功');
                  _this.closeDialog();
                  _this.loading = false;
                }).catch(function () {
                  _this.loading = false;
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    closeDialog: function closeDialog() {
      this.$refs.form.resetFields();
      this.$emit('closeDialog');
    }
  }
});

/***/ }),

/***/ 1772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOnBatchSucceedButton_vue__ = __webpack_require__(1601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c4ebeb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOnBatchSucceedButton_vue__ = __webpack_require__(1773);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOnBatchSucceedButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c4ebeb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOnBatchSucceedButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1773:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"danger","size":"mini","disabled":_vm.batchid < 1},on:{"click":_vm.onSubmit}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOnBatchWithdrawButton_vue__ = __webpack_require__(1602);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f84842_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOnBatchWithdrawButton_vue__ = __webpack_require__(1775);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOnBatchWithdrawButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f84842_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOnBatchWithdrawButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"danger","disabled":_vm.batchid < 1,"size":"mini"},on:{"click":_vm.onSubmit}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOnBatchCheckButton_vue__ = __webpack_require__(1603);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_519efb16_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOnBatchCheckButton_vue__ = __webpack_require__(1784);
function injectStyle (ssrContext) {
  __webpack_require__(1777)
  __webpack_require__(1779)
  this["$style"] = __webpack_require__(1781)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-519efb16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOnBatchCheckButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_519efb16_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOnBatchCheckButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1777:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1778);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("76124ede", content, true, {});

/***/ }),

/***/ 1778:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderOnBatchCheckButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1779:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1780);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7602f3c7", content, true, {});

/***/ }),

/***/ 1780:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".image-list .image-drop-shadow[data-v-519efb16]{padding:5px;border:1px solid #efefef}.image-list a[data-v-519efb16]{margin-right:10px;margin-bottom:10px}.image-list a:hover img.image-drop-shadow[data-v-519efb16]{border:1px solid #ccc;-webkit-box-shadow:1px 1px 5px #999;box-shadow:1px 1px 5px #999}", "", {"version":3,"sources":["/workspace/src/views/order/components/buttons/OrderOnBatchCheckButton.vue"],"names":[],"mappings":"AACA,gDAAgD,YAAY,wBAAwB,CACnF,AACD,+BAA+B,kBAAkB,kBAAkB,CAClE,AACD,2DAA2D,sBAAsB,oCAAoC,2BAA2B,CAC/I","file":"OrderOnBatchCheckButton.vue","sourcesContent":["\n.image-list .image-drop-shadow[data-v-519efb16]{padding:5px;border:solid 1px #EFEFEF\n}\n.image-list a[data-v-519efb16]{margin-right:10px;margin-bottom:10px\n}\n.image-list a:hover img.image-drop-shadow[data-v-519efb16]{border:solid 1px #CCC;-webkit-box-shadow:1px 1px 5px #999;box-shadow:1px 1px 5px #999\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1781:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1782);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c447d096", content, true, {});

/***/ }),

/***/ 1782:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderOnBatchCheckButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchRules */
/* unused harmony export formRules */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return batchRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的工单ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入工单名称', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入至少2个字符', 'string'), { min: 2 })]
};

var batchRules = {
  file: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请上传文件', 'object'))],
  starttime: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择时间'))],
  orderid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入工单id', 'integer'))]
};

/***/ }),

/***/ 1784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('el-button',{attrs:{"size":"mini","type":"warning","disabled":_vm.batchid < 1},on:{"click":function($event){_vm.dialogFormVisible = true}}},[_vm._t("default")],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"按批次审核","visible":_vm.dialogFormVisible},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.batchRules}},[_c('el-form-item',{attrs:{"label":"上传Excel","prop":"file","label-width":"120px"}},[_c('el-upload',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"uploadThumb",staticClass:"re-el-upload-width-max",attrs:{"drag":"","multiple":false,"limit":1,"action":"","before-upload":_vm.beforeAvatarUpload,"accept":".xlsx,.xls","http-request":_vm.uploadRequest}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击选择文件")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",staticStyle:{"margin-top":"0"},attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能选择Microsoft Office Excel文件，且不超过2048kb\n        ")])])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开始时间","label-width":"120px","prop":"starttime"}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期时间","value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.form.starttime),callback:function ($$v) {_vm.$set(_vm.form, "starttime", $$v)},expression:"form.starttime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工单ID","prop":"orderid","label-width":"120px"}},[_c('el-input',{attrs:{"placeholder":"请输入工单id"},model:{value:(_vm.form.orderid),callback:function ($$v) {_vm.$set(_vm.form, "orderid", $$v)},expression:"form.orderid"}})],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"width":"50%","title":"提示","visible":_vm.innerVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.innerVisible=$event}}},[_c('span',[_vm._v("按批次审核是否需要检测?")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.onDetection}},[_vm._v("不需要")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("需要")])],1)]),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogFormVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onOpenInner}},[_vm._v("确 定\n    ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2021:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderAllowanceDialog_vue__ = __webpack_require__(1692);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b25c8bde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderAllowanceDialog_vue__ = __webpack_require__(2028);
function injectStyle (ssrContext) {
  __webpack_require__(2022)
  __webpack_require__(2024)
  this["$style"] = __webpack_require__(2026)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b25c8bde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderAllowanceDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b25c8bde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderAllowanceDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2022:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2023);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6afabe4b", content, true, {});

/***/ }),

/***/ 2023:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderAllowanceDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2024:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2025);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("9ef741c6", content, true, {});

/***/ }),

/***/ 2025:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderAllowanceDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2026:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2027);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("ed8f06d6", content, true, {});

/***/ }),

/***/ 2027:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderAllowanceDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2028:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"用户补贴","visible":_vm.visible,"before-close":_vm.closeDialog,"width":"500px"}},[_c('div',{staticStyle:{"text-align":"center","font-size":"20px"}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"项目ID","prop":"name"}},[_vm._v("\n            "+_vm._s(_vm.info.projectid)+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"用户ID","prop":"name"}},[_vm._v("\n            "+_vm._s(_vm.info.userid)+"\n          ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属省份","prop":"name"}},[_vm._v("\n            "+_vm._s(_vm.info.province_name)+"\n          ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"可用金额","prop":"name"}},[_vm._v("\n            "+_vm._s(_vm.info.remain_amount)+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"补贴金额","prop":"name"}},[_c('el-input',{model:{value:(_vm.form.allowance),callback:function ($$v) {_vm.$set(_vm.form, "allowance", $$v)},expression:"form.allowance"}})],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("确定\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("取消")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_OrderOnBatchSucceedButton__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_buttons_OrderOnBatchWithdrawButton__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_buttons_OrderOnBatchCheckButton__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_task_components_buttons_TaskDescButton__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_order_components_OrderAllowanceDialog__ = __webpack_require__(2021);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// 审核通过状态值（工单复核页强制只查此状态）
var AUDIT_PASSED_STATUS = 5;

// 复核状态枚举：空/0 待复核，1 复核正常，2 复核异常，3 分配中
var REVIEW_STATUS_MAP = {
  0: '待复核',
  1: '复核正常',
  2: '复核异常',
  3: '分配中'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__core_mixins_table_v3__["a" /* default */]],
  components: {
    OrderOnBatchSucceedButton: __WEBPACK_IMPORTED_MODULE_6__components_buttons_OrderOnBatchSucceedButton__["a" /* default */],
    OrderOnBatchWithdrawButton: __WEBPACK_IMPORTED_MODULE_7__components_buttons_OrderOnBatchWithdrawButton__["a" /* default */],
    OrderOnBatchCheckButton: __WEBPACK_IMPORTED_MODULE_8__components_buttons_OrderOnBatchCheckButton__["a" /* default */],
    TaskDescButton: __WEBPACK_IMPORTED_MODULE_9__views_task_components_buttons_TaskDescButton__["a" /* default */],
    OrderAllowanceDialog: __WEBPACK_IMPORTED_MODULE_10__views_order_components_OrderAllowanceDialog__["a" /* default */]
  },
  data: function data() {
    return {
      table: [],
      multipleSelection: [],
      dialogVisible: false,
      dialogAllowanceVisible: false,
      dialogSneakSimilarVisible: false,
      dialogExchangeOrderVisible: false,
      exportCount: 0,
      search: {
        platformtype: null,
        onlineRange: [],
        offlineRange: [],
        reformat: 1,
        start_begin: null,
        start_end: null,
        endtime_begin: null,
        endtime_end: null,
        customerid: null,
        projectid: [],
        type: null,
        batchid: [],
        status: [AUDIT_PASSED_STATUS], // 工单复核页强制只查「审核通过」
        templateid: null,
        addto_taskgroup_target_num: null,
        userid: null,
        taskmarketareaid: null,
        marketname: null,
        locked: null,
        text: null,
        review_begin: null,
        review_end: null,
        sort_by_review: null,
        sort_by_lastupdatetime: null,
        sort_by_endtime: null,
        userfinishtime: [],
        audit_at_begin: null,
        audit_at_end: null,
        first_reviewerid: null,
        recheckerid: null,
        cstaskstatus: null,
        allocation_status: null,
        orderid: null,
        not_type: [21]
      },
      searchFieldType: {
        type: Number,
        status: Array,
        locked: Number,
        review_begin: Number,
        review_end: Number,
        taskmarketareaid: Number,
        addto_taskgroup_target_num: Number,
        recheckerid: Number,
        cstaskstatus: Number,
        allocation_status: Number
      },
      exportAsync: false,
      convert_midan_task: false,
      dashboardFormat: false,
      exchangeOrderForm: {
        orderid1: null,
        orderid2: null
      },
      allowanceInfo: {
        order_ids: [],
        provinceid: 0,
        projectid: 0,
        userid: 0,
        remain_amount: 0
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  }), {
    reviewStatusOptions: function reviewStatusOptions() {
      return [{ label: '待复核', value: 0 }, { label: '复核正常', value: 1 }, { label: '复核异常', value: 2 }];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, request.map(['getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail', 'getQueryReviewTaskList']), Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']), {
    // 项目下拉：合并分页等默认参数，避免空参数导致 query_project 接口报错
    getProjectTableQuery: function getProjectTableQuery(params) {
      return request('getProjectTable', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({ per_page: 20, current_page: 1 }, params || {}));
    },

    /**
     * 获取实习生列表（统一走 audit-intern.api.js 中的 queryInternTableApi）
     */
    getInternUserTable: function getInternUserTable(params) {
      return request('queryInternTableApi', params);
    },

    /**
     * 获取实习生详情（使用 audit-intern.api.js 中的 getInternBaseInfoApi）
     */
    getInternUserDetail: function getInternUserDetail(params) {
      return request('getInternBaseInfoApi', params);
    },
    projectIdChanged: function projectIdChanged() {
      if (this.search.batchid && this.search.batchid.length > 0) {
        this.search.batchid = [];
      }
    },
    handleSearch: function handleSearch() {
      if (this.search.userfinishtime && this.search.userfinishtime.length === 2) {
        this.search.audit_at_begin = this.search.userfinishtime[0];
        this.search.audit_at_end = this.search.userfinishtime[1];
      } else {
        this.search.audit_at_begin = null;
        this.search.audit_at_end = null;
      }
      this.onSearch();
    },
    getReviewStatusLabel: function getReviewStatusLabel(value) {
      if (value === 1 || value === 2) {
        return REVIEW_STATUS_MAP[value];
      }
      return '待复核';
    },
    getAllocationStatusLabel: function getAllocationStatusLabel(row) {
      if (row.reviewer_id != null && row.reviewer_id !== '' && row.reviewer_name != null && row.reviewer_name !== '') {
        return '已分配';
      }
      return '未分配';
    },
    getTableData: function getTableData(params) {
      var _this = this;

      var mergedParams = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, params);
      var requestParams = {
        page: mergedParams.current_page,
        per_page: mergedParams.per_page,
        projectid: mergedParams.projectid,
        batchid: mergedParams.batchid,
        taskmarketareaid: mergedParams.taskmarketareaid,
        first_reviewerid: mergedParams.first_reviewerid,
        cstaskstatus: mergedParams.cstaskstatus,
        recheckerid: mergedParams.recheckerid,
        audit_at_begin: mergedParams.audit_at_begin,
        audit_at_end: mergedParams.audit_at_end,
        taskid: mergedParams.taskid,
        orderid: mergedParams.orderid,
        audit_status: mergedParams.audit_status,
        review_status: mergedParams.review_status,
        customer_id: mergedParams.customer_id
        // 分配状态：0 未分配 1 已分配（无默认值，未选时不传）
      };if (mergedParams.allocation_status === 0 || mergedParams.allocation_status === 1) {
        requestParams.allocation_status = mergedParams.allocation_status;
      }
      return request.page('getQueryReviewTaskList', requestParams).then(function (res) {
        var body = res.data || {};
        // 接口返回 data 为分页对象时：data.data 为列表
        var paginator = body.data || {};
        var list = (paginator.data || body.data || []).map(function (item) {
          return _this.mapAuditedResultToRow(item);
        });
        return {
          data: {
            data: list,
            total: paginator.total != null ? paginator.total : body.total || 0,
            current_page: paginator.current_page != null ? paginator.current_page : body.current_page || 1,
            per_page: paginator.per_page != null ? paginator.per_page : body.per_page || 20
          }
        };
      });
    },

    // 将 audited_order_result + audit_task 转为表格行（主表一条，从表取一条）
    mapAuditedResultToRow: function mapAuditedResultToRow(item) {
      var task = item.audit_task || {};
      return {
        id: item.id,
        orderid: item.orderid,
        title: task.title || item.task_market_name || '',
        type: task.type,
        userid: task.userid != null ? task.userid : item.userid,
        user_name: task.user_name || item.user_name || '',
        salary: task.salary,
        starttime: task.starttime || item.task_starttime || '',
        endtime: task.endtime || item.task_endtime || '',
        provincename: task.provincename || '',
        cityname: task.cityname || '',
        areaname: task.areaname || '',
        marketname: task.marketname || item.task_market_name || '',
        marketid: task.marketid || item.task_market_id,
        status: task.status,
        isInAudit: Number(item.audit_status) === 1,
        cstaskstatus: item.review_status,
        reviewer_id: item.reviewer_id,
        reviewer_name: item.reviewer_name || '',
        adminname: task.adminname || item.task_creator_name || '',
        customerid: task.customerid != null ? task.customerid : item.customer_id,
        customername: task.customername || '',
        customernumber: task.customernumber || '',
        review: task.review != null ? task.review : item.audit_times,
        lastupdatetime: task.lastupdatetime || '',
        publishtime: task.publishtime || '',
        taskid: item.taskid,
        batchid: task.batchid != null ? task.batchid : item.batchid,
        batchname: task.batchname || task.batch_name || item.batch_name || item.batchname || '',
        batch_detail: task.batch_detail || item.batch_detail || ''
      };
    },
    formatBatchCell: function formatBatchCell(row) {
      var name = (row.batchname || row.batch_detail || '').trim();
      if (name) return name;
      if (row.batchid != null && row.batchid !== '') return String(row.batchid);
      return '-';
    },
    formatReviewerCell: function formatReviewerCell(row) {
      var name = (row.reviewer_name || '').trim();
      var id = row.reviewer_id != null && row.reviewer_id !== '' ? String(row.reviewer_id).trim() : '';
      if (name && id) return name + '/' + id;
      if (name) return name;
      if (id) return id;
      return '';
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchSucceed: function batchSucceed() {
      this.$refs.multipleTable.clearSelection();
      this.onSearch();
    },
    sortChange: function sortChange(column, prop, order) {
      var sortBy = 'asc';
      if (column.order === 'descending') {
        sortBy = 'desc';
      }
      if (column.prop === 'lastupdatetime') {
        this.search.sort_by_lastupdatetime = sortBy;
      } else if (column.prop === 'endtime') {
        this.search.sort_by_endtime = sortBy;
      }
      this.onSearch();
    },
    onExportPage: function onExportPage(onlyBasic, dashboardFormat) {
      this.dialogVisible = false;
      var multipleIds = {
        orderid: this.multipleSelection.map(function (item) {
          return item.orderid;
        }),
        only_basic: onlyBasic,
        export_async: this.exportAsync,
        dashboard_format: dashboardFormat,
        convert_midan_task: this.convert_midan_task
      };

      if (multipleIds.orderid.length <= 0) {
        this.$message.error('请至少选择批量导出一个');
        return false;
      }

      if (this.exportAsync) {
        return this.onExportAsync(multipleIds);
      }

      this.$export(this.$route.meta.title + '-' + this.pagination.current_page + 'P', {
        fileHeader: this.exportHeader,
        total: multipleIds.orderid.length,
        request: function (_request) {
          function request(_x) {
            return _request.apply(this, arguments);
          }

          request.toString = function () {
            return _request.toString();
          };

          return request;
        }(function (params) {
          return request('exportOrder', params);
        }),
        requestParams: multipleIds,
        fileType: 'csv',
        type: 'array',
        getResponseData: function getResponseData(data) {
          data.current_page > 1 && data.data.splice(0, 1);
          return data;
        }
      });
    },
    onExportSearch: function onExportSearch() {
      var _this2 = this;

      if (!this.pagination.total) {
        this.$message.warning('当前没有可导出的数据');
        return;
      }
      var searchParams = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.search);
      if (this.search.userfinishtime && this.search.userfinishtime.length === 2) {
        searchParams.audit_at_begin = this.search.userfinishtime[0];
        searchParams.audit_at_end = this.search.userfinishtime[1];
      }
      this.$export(this.$route.meta.title + '-\u641C\u7D22\u7ED3\u679C-' + this.pagination.current_page + 'P', {
        fileHeader: this.getSearchExportHeaders(),
        total: this.pagination.total,
        request: function request(params) {
          return _this2.getTableData(params);
        },
        requestParams: searchParams,
        fileType: 'csv'
      });
    },
    onExportAsync: function onExportAsync(detail) {
      var _this3 = this;

      return request.common('exportOrder', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, detail, { status: [AUDIT_PASSED_STATUS] })).then(function () {
        return _this3.$message.success('创建成功，请在任务管理中心查看！');
      });
    },
    showExchangeOrderDialog: function showExchangeOrderDialog() {
      this.$set(this, 'exchangeOrderForm', {
        orderid1: null,
        orderid2: null
      });
      this.dialogExchangeOrderVisible = true;
    },
    closeExchangeOrderDialog: function closeExchangeOrderDialog() {
      this.dialogExchangeOrderVisible = false;
    },
    showExportSneakSimilarityDialog: function showExportSneakSimilarityDialog() {
      this.exportCount = this.pagination.total;
      this.dialogSneakSimilarVisible = true;
    },
    countDown: function countDown(date) {
      var futureTs = (Date.parse(date) + '').substr(0, 10);
      var currentTs = (new Date().getTime() + '').substr(0, 10);
      var interval = futureTs - currentTs;

      if (interval < 0) {
        return '';
      }

      return filter.formatTimerHumanize(interval);
    },
    showExportDialog: function showExportDialog() {
      this.dialogVisible = true;
      this.exportAsync = false;
      this.convert_midan_task = false;
    },
    showExportSearchDialog: function showExportSearchDialog() {
      this.onExportSearch();
    },
    getSearchExportHeaders: function getSearchExportHeaders() {
      var _this4 = this;

      return [{
        key: 'orderid',
        text: '工单ID',
        formatter: function formatter(row) {
          return 'ORD' + (row.orderid || '');
        }
      }, {
        key: 'customer',
        text: '所属客户',
        formatter: function formatter(row) {
          if (row.customerid) {
            return (row.customername || '') + '/' + (row.customernumber || '');
          }
          return '平台';
        }
      }, {
        key: 'batchname',
        text: '所属批次',
        formatter: function formatter(row) {
          return _this4.formatBatchCell(row);
        }
      }, {
        key: 'title',
        text: '任务名称',
        formatter: function formatter(row) {
          return row.title || '';
        }
      }, {
        key: 'userid',
        text: '零工ID',
        formatter: function formatter(row) {
          if (row.userid && row.userid !== 0) {
            return row.user_name ? row.userid + ' | ' + row.user_name : '' + row.userid;
          }
          return row.user_name || '-';
        }
      }, {
        key: 'salary',
        text: '赏金',
        formatter: function formatter(row) {
          return _this4.salaryValue(row.salary);
        }
      }, {
        key: 'task_time',
        text: '任务时间',
        formatter: function formatter(row) {
          return (row.starttime || '') + ' - ' + (row.endtime || '');
        }
      }, {
        key: 'city',
        text: '城市',
        formatter: function formatter(row) {
          return '' + (row.provincename || '') + (row.cityname || '') + (row.areaname || '');
        }
      }, {
        key: 'marketname',
        text: '门店名称',
        formatter: function formatter(row) {
          return filter.sjfmarketname(row.marketname, row.type);
        }
      }, {
        key: 'status',
        text: '任务状态',
        formatter: function formatter(row) {
          return _this4.getTaskStatusLabel(row.status);
        }
      }, {
        key: 'allocation_status',
        text: '分配状态',
        formatter: function formatter(row) {
          return _this4.getAllocationStatusLabel(row);
        }
      }, {
        key: 'cstaskstatus',
        text: '复核状态',
        formatter: function formatter(row) {
          return _this4.getReviewStatusLabel(row.cstaskstatus);
        }
      }, {
        key: 'reviewer',
        text: '复核人',
        formatter: function formatter(row) {
          return _this4.formatReviewerCell(row);
        }
      }, {
        key: 'adminname',
        text: '任务发布人',
        formatter: function formatter(row) {
          return row.adminname || '';
        }
      }, {
        key: 'lastupdatetime',
        text: '更新时间',
        formatter: function formatter(row) {
          return row.lastupdatetime || '';
        }
      }];
    },
    getTaskStatusLabel: function getTaskStatusLabel(value) {
      var statusItem = (this.options.status || []).find(function (item) {
        return item.value === value;
      });
      return statusItem ? statusItem.label : '';
    },
    showAssignReviewBySearchDialog: function showAssignReviewBySearchDialog() {
      var searchCopy = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.search);
      if (this.search.userfinishtime && this.search.userfinishtime.length === 2) {
        searchCopy.audit_at_begin = this.search.userfinishtime[0];
        searchCopy.audit_at_end = this.search.userfinishtime[1];
      }
      searchCopy.status = [AUDIT_PASSED_STATUS];
      sessionStorage.setItem('assign_review_params', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
        mode: 'search',
        search: searchCopy
      }));
      var query = { mode: 'search' };
      var searchParams = ['projectid', 'batchid', 'taskmarketareaid', 'first_reviewerid', 'cstaskstatus', 'allocation_status', 'recheckerid', 'audit_at_begin', 'audit_at_end', 'orderid'];
      searchParams.forEach(function (key) {
        var v = searchCopy[key];
        if (v !== undefined && v !== null && v !== '') {
          query[key] = Array.isArray(v) ? v.join(',') : v;
        }
      });
      this.$router.push({ path: '/order/assign-review', query: query });
    },
    showAssignReviewBySelectionDialog: function showAssignReviewBySelectionDialog() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请先勾选要分配复核人的工单');
        return;
      }
      var orderIds = this.multipleSelection.map(function (item) {
        return item.orderid;
      });
      sessionStorage.setItem('assign_review_params', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
        mode: 'selection',
        orderIds: orderIds
      }));
      this.$router.push({
        path: '/order/assign-review',
        query: { mode: 'selection', orderid: orderIds.join(',') }
      });
    },
    showAllowanceDialog: function showAllowanceDialog() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var multipleIds, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                multipleIds = {
                  orderid: _this5.multipleSelection.map(function (item) {
                    return item.orderid;
                  })
                };

                if (!(multipleIds.orderid.length <= 0)) {
                  _context.next = 4;
                  break;
                }

                _this5.$message.error('请至少选择一个工单');
                return _context.abrupt('return', false);

              case 4:
                if (_this5.multipleSelection.every(function (v) {
                  return v.provinceid === _this5.multipleSelection[0].provinceid;
                })) {
                  _context.next = 7;
                  break;
                }

                _this5.$message.error('工单省份不一致');
                return _context.abrupt('return', false);

              case 7:
                params = {
                  order_ids: multipleIds.orderid,
                  provinceid: _this5.multipleSelection[0].provinceid,
                  province_name: _this5.multipleSelection[0].provincename,
                  projectid: _this5.getFirstSearchProjectId(),
                  userid: _this5.search.userid
                };

                _this5.allowanceInfo = params;
                _context.next = 11;
                return request.common('getExecutiveAllowance', params).then(function (data) {
                  _this5.allowanceInfo.remain_amount = data.data ? data.data : 0;
                });

              case 11:

                _this5.dialogAllowanceVisible = true;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    salaryValue: function salaryValue(value) {
      return filter.hasPermission(250) ? value : '*';
    },
    getFirstSearchProjectId: function getFirstSearchProjectId() {
      if (this.search.projectid.length !== 1) {
        return '-1';
      }
      return _.first(this.search.projectid);
    },
    getFirstSearchBatchId: function getFirstSearchBatchId() {
      if (this.search.projectid.length !== 1 || this.search.batchid.length !== 1) {
        return '-1';
      }
      return _.first(this.search.batchid);
    },
    onExportOrderSneakSimilarity: function onExportOrderSneakSimilarity() {
      var _this6 = this;

      var params = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.search, {
        status: [AUDIT_PASSED_STATUS],
        convert_midan_task: this.convert_midan_task
      });
      request.common('exportOrderSneakSimilarity', params).then(function (data) {
        _this6.$confirm('抓拍相似度导出任务创建成功，请是否前往批量任务列表中查看?', '提示', { type: 'success' }).then(function () {
          _this6.$router.push({ path: '/task/batch/table' });
        });
      });
    },
    doExchangeOrder: function doExchangeOrder() {
      var _this7 = this;

      var params = _.cloneDeep(this.exchangeOrderForm);
      this.$confirm('\u786E\u5B9A\u8981\u4EA4\u6362\u5DE5\u53551 (' + params.orderid1 + ') \u4E0E\u5DE5\u53552 (' + params.orderid2 + ') \u7684\u53D6\u8BC1\u6570\u636E\u5417\uFF1F', '操作提示', { type: 'info' }).then(function () {
        request.common('allowExchangeOrderApi', params).then(function (_ref) {
          var data = _ref.data;

          if (data.canExchange === false) {
            if (data.canForceExchange === true) {
              _this7.$confirm(data.msg + ', <strong style="color: red;">\u786E\u5B9A\u8981\u7EE7\u7EED\u5F3A\u5236\u4EA4\u6362\u5DE5\u5355\u6570\u636E\u5417\uFF1F</strong>', '强制交换数据提示', { type: 'warning', dangerouslyUseHTMLString: true }).then(function () {
                _this7.callExchangeOrderApi(params);
              }).catch(function () {});
            } else {
              _this7.$alert('' + data.msg, '禁止交换工单', { type: 'error' });
            }
          } else if (data.canExchange === true) {
            _this7.callExchangeOrderApi(params);
          }
        }).catch(function () {});
      });
    },
    callExchangeOrderApi: function callExchangeOrderApi(params) {
      var _this8 = this;

      request.common('exchangeOrderApi', params).then(function (_ref2) {
        var data = _ref2.data;

        _this8.$message.success('数据交换成功');
        _this8.closeExchangeOrderDialog();
      });
    }
  })
});

/***/ }),

/***/ 4797:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4798);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5d9e5898", content, true, {});

/***/ }),

/***/ 4798:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".order-review-table .el-table__body td .cell[data-v-44269044],.order-review-table .el-table__header th .cell[data-v-44269044]{padding:10px 12px;line-height:1.5}.order-review-table .el-table__header th .cell[data-v-44269044]{font-weight:500}.order-review-table .cell-wrap[data-v-44269044]{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-clamp:2;overflow:hidden;word-break:break-all;line-height:1.5}.order-review-table .cell-link .cell-wrap[data-v-44269044]{display:-webkit-box}.el-dialog .el-checkbox[data-v-44269044]{white-space:normal}.el-dialog .el-checkbox[data-v-44269044] .el-checkbox__label{display:inline}", "", {"version":3,"sources":["/workspace/src/views/order/pages/AssignedReviewTable.vue"],"names":[],"mappings":"AACA,8HAA8H,kBAAkB,eAAe,CAC9J,AACD,gEAAgE,eAAe,CAC9E,AACD,gDAAgD,oBAAoB,4BAA4B,qBAAqB,aAAa,gBAAgB,qBAAqB,eAAe,CACrL,AACD,2DAA2D,mBAAmB,CAC7E,AACD,yCAAyC,kBAAkB,CAC1D,AACD,6DAA6D,cAAc,CAC1E","file":"AssignedReviewTable.vue","sourcesContent":["\n.order-review-table .el-table__body td .cell[data-v-44269044],.order-review-table .el-table__header th .cell[data-v-44269044]{padding:10px 12px;line-height:1.5\n}\n.order-review-table .el-table__header th .cell[data-v-44269044]{font-weight:500\n}\n.order-review-table .cell-wrap[data-v-44269044]{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-clamp:2;overflow:hidden;word-break:break-all;line-height:1.5\n}\n.order-review-table .cell-link .cell-wrap[data-v-44269044]{display:-webkit-box\n}\n.el-dialog .el-checkbox[data-v-44269044]{white-space:normal\n}\n.el-dialog .el-checkbox[data-v-44269044] .el-checkbox__label{display:inline\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("审单管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":true}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"120px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.handleSearch($event)}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"项目","prop":"projectid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请选择","query-request":_vm.getProjectTableQuery,"find-request":_vm.getProjectDetail},on:{"change":_vm.projectIdChanged},model:{value:(_vm.search.projectid),callback:function ($$v) {_vm.$set(_vm.search, "projectid", $$v)},expression:"search.projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"批次","prop":"batchid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","disabled":!_vm.search.projectid || !_vm.search.projectid.length,"id-key":"number","label-key":"detail","value-key":"id","placeholder":"请选择","query-request":function (_) { return _vm.getBatchTable(Object.assign({projectid: _vm.search.projectid}, _)); },"find-request":_vm.getBatchDetail},model:{value:(_vm.search.batchid),callback:function ($$v) {_vm.$set(_vm.search, "batchid", $$v)},expression:"search.batchid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所在区域","prop":"taskmarketareaid"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择","clearable":""},model:{value:(_vm.search.taskmarketareaid),callback:function ($$v) {_vm.$set(_vm.search, "taskmarketareaid", $$v)},expression:"search.taskmarketareaid"}},_vm._l((_vm.options.taskmarketareaid),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"初审管理员","prop":"first_reviewerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请选择实习生","query-request":_vm.getInternUserTable,"find-request":_vm.getInternUserDetail},model:{value:(_vm.search.first_reviewerid),callback:function ($$v) {_vm.$set(_vm.search, "first_reviewerid", $$v)},expression:"search.first_reviewerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"复核状态","prop":"cstaskstatus"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择","clearable":""},model:{value:(_vm.search.cstaskstatus),callback:function ($$v) {_vm.$set(_vm.search, "cstaskstatus", $$v)},expression:"search.cstaskstatus"}},_vm._l((_vm.reviewStatusOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"分配状态","prop":"allocation_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择","clearable":""},model:{value:(_vm.search.allocation_status),callback:function ($$v) {_vm.$set(_vm.search, "allocation_status", $$v)},expression:"search.allocation_status"}},[_c('el-option',{attrs:{"label":"未分配","value":0}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已分配","value":1}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"复核人","prop":"recheckerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请选择","query-request":_vm.getPlatformUsersIndex,"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.recheckerid),callback:function ($$v) {_vm.$set(_vm.search, "recheckerid", $$v)},expression:"search.recheckerid"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"re-el-form__interval",attrs:{"label":"审核通过时间","prop":"userfinishtime"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"请选择","end-placeholder":"请选择","align":"right","clearable":"","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.userfinishtime),callback:function ($$v) {_vm.$set(_vm.search, "userfinishtime", $$v)},expression:"search.userfinishtime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工单ID高级检索","prop":"orderid","label-width":"120px"}},[_c('el-input',{attrs:{"placeholder":"多个用逗号分隔","clearable":""},model:{value:(_vm.search.orderid),callback:function ($$v) {_vm.$set(_vm.search, "orderid", $$v)},expression:"search.orderid"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit","size":"mini"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning","size":"mini"},on:{"click":_vm.showExportSearchDialog}},[_vm._v("按搜索结果导出\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.showAssignReviewBySearchDialog}},[_vm._v("按搜索结果分配复核\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"sj-icon-export"},on:{"click":_vm.showExportDialog}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.showAssignReviewBySelectionDialog}},[_vm._v("按勾选分配复核人\n      ")]),_vm._v(" "),(_vm.search.projectid.length > 0 && _vm.search.userid > 0)?_c('el-tooltip',{attrs:{"content":"请确保搜索条件中的 项目 的已选条目个数为 1 个","disabled":_vm.getFirstSearchProjectId() > 0,"placement":"top","effect":"dark"}},[_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"disabled":_vm.getFirstSearchProjectId() < 1,"type":"primary","size":"mini"},on:{"click":_vm.showAllowanceDialog}},[_vm._v("执行补贴\n        ")])],1):_vm._e()],1),_vm._v(" "),_c('el-table',{ref:"multipleTable",staticClass:"order-review-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""},on:{"selection-change":_vm.handleSelectionChange,"sort-change":_vm.sortChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"55"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"orderid","width":"116px","label":"工单ID"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          ORD"+_vm._s(scope.row.orderid)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":"所属客户","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.customerid)?_c('span',[_vm._v(_vm._s(scope.row.customername)+"/"+_vm._s(scope.row.customernumber))]):_vm._e(),_vm._v(" "),(!scope.row.customerid)?_c('span',[_vm._v("平台")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"batchname","label":"所属批次","min-width":"120","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"cell-wrap",attrs:{"title":_vm.formatBatchCell(scope.row)}},[_vm._v(_vm._s(_vm.formatBatchCell(scope.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":"任务名称","min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{staticClass:"cell-link",staticStyle:{"text-decoration":"none"},attrs:{"to":'/order/detail/'+scope.row.orderid}},[_c('span',{staticClass:"cell-wrap",staticStyle:{"color":"rgb(88,157,248)"},attrs:{"title":scope.row.title}},[_vm._v(_vm._s(scope.row.title))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userid","label":"零工ID","width":"120px","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.userid && scope.row.userid !== 0)?[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/users/table?keyword='+scope.row.userid}},[_c('span',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v(_vm._s(scope.row.userid))]),_vm._v(" "),(scope.row.user_name)?_c('span',[_vm._v(" | "+_vm._s(scope.row.user_name))]):_vm._e()])]:_c('span',[_vm._v(_vm._s(scope.row.user_name || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salary","label":"赏金","width":"65px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.salaryValue(scope.row.salary))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"任务时间","width":"100px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"cell-wrap",attrs:{"title":scope.row.starttime + ' - ' + scope.row.endtime}},[_vm._v(_vm._s(scope.row.starttime)+" - "+_vm._s(scope.row.endtime))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"城市","min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"cell-wrap",attrs:{"title":scope.row.provincename + scope.row.cityname + scope.row.areaname}},[_vm._v(_vm._s(scope.row.provincename)+_vm._s(scope.row.cityname)+_vm._s(scope.row.areaname))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marketname","label":"门店名称"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":'/market/table?id='+scope.row.marketid,"target":"_blank"}},[_vm._v("\n            "+_vm._s(_vm._f("sjfmarketname")(scope.row.marketname,scope.row.type))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"任务状态","width":"92px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.status),function(item){return (scope.row.status === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"分配状态","width":"94px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.getAllocationStatusLabel(scope.row))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cstaskstatus","label":"复核状态","width":"94px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.getReviewStatusLabel(scope.row.cstaskstatus))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"reviewer","label":"复核人","min-width":"120","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"cell-wrap",attrs:{"title":_vm.formatReviewerCell(scope.row)}},[_vm._v(_vm._s(_vm.formatReviewerCell(scope.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"adminname","label":"任务发布人","width":"94px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"更新时间","sortable":"custom","width":"100px","prop":"lastupdatetime"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"cell-wrap",attrs:{"title":scope.row.lastupdatetime}},[_vm._v(_vm._s(scope.row.lastupdatetime))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"120px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type === 127)?[_c('router-link',{attrs:{"to":("/order/md/table/" + (scope.row.taskid))}},[_c('el-button',{attrs:{"type":"success","size":"mini"}},[_vm._v("查看包含工单\n              ")])],1)]:[_c('router-link',{attrs:{"to":'/order/review/'+scope.row.orderid,"target":"_blank"}},[_c('el-button',{attrs:{"type":"success","size":"mini"}},[_vm._v("查看\n              ")])],1)]]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"导出数据确认","visible":_vm.dialogVisible,"width":"45%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticStyle:{"font-size":"large"}},[_vm._v("共导出"+_vm._s(_vm.multipleSelection.length)+"条数据")]),_vm._v(" "),_c('el-checkbox',{staticClass:"margin t20",model:{value:(_vm.exportAsync),callback:function ($$v) {_vm.exportAsync=$$v},expression:"exportAsync"}},[_vm._v("后台异步导出（建议1w条数据以上时勾选，勾选后请于批量任务列表确认导出数据）\n    ")]),_vm._v(" "),_c('el-checkbox',{staticClass:"margin t20",staticStyle:{"margin-left":"0"},model:{value:(_vm.convert_midan_task),callback:function ($$v) {_vm.convert_midan_task=$$v},expression:"convert_midan_task"}},[_vm._v("米单类型任务转为组内任务导出\n    ")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","disabled":_vm.multipleSelection.length === 0,"size":"mini"},on:{"click":function($event){return _vm.onExportPage(0, 1)}}},[_vm._v("按Dashboard格式导出")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.multipleSelection.length === 0,"size":"mini"},on:{"click":function($event){return _vm.onExportPage(1, 0)}}},[_vm._v("仅导出任务基本数据")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.multipleSelection.length === 0,"size":"mini"},on:{"click":function($event){return _vm.onExportPage(0, 0)}}},[_vm._v("导出任务全部数据")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取消")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"导出前置抓拍准确率数据确认","visible":_vm.dialogSneakSimilarVisible,"width":"30%"},on:{"update:visible":function($event){_vm.dialogSneakSimilarVisible=$event}}},[_c('div',{staticStyle:{"font-size":"large"}},[_vm._v("共导出"+_vm._s(_vm.exportCount)+"条数据")]),_vm._v(" "),_c('el-checkbox',{staticClass:"margin t20",staticStyle:{"margin-left":"0"},model:{value:(_vm.convert_midan_task),callback:function ($$v) {_vm.convert_midan_task=$$v},expression:"convert_midan_task"}},[_vm._v("米单类型任务转为组内任务导出\n    ")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"mini","disabled":_vm.exportCount === 0},on:{"click":function($event){return _vm.onExportOrderSneakSimilarity()}}},[_vm._v("导出数据")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function () { _vm.dialogSneakSimilarVisible = false; _vm.convert_midan_task = false;}}},[_vm._v("取消")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"工单数据交换","visible":_vm.dialogExchangeOrderVisible,"close-on-press-escape":false,"close-on-click-modal":false,"width":"40%"},on:{"update:visible":function($event){_vm.dialogExchangeOrderVisible=$event}}},[_c('el-form',{ref:"exchangeOrderForm",attrs:{"model":_vm.exchangeOrderForm,"label-width":"96px","size":"medium"}},[_c('el-form-item',{attrs:{"label":"工单1 ID","prop":"orderid1"}},[_c('el-input',{attrs:{"placeholder":"请输入工单ID,必须为纯数字,例如 66534128"},model:{value:(_vm.exchangeOrderForm.orderid1),callback:function ($$v) {_vm.$set(_vm.exchangeOrderForm, "orderid1", $$v)},expression:"exchangeOrderForm.orderid1"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工单2 ID","prop":"orderid2"}},[_c('el-input',{attrs:{"placeholder":"请输入工单ID,必须为纯数字,例如 66534128"},model:{value:(_vm.exchangeOrderForm.orderid2),callback:function ($$v) {_vm.$set(_vm.exchangeOrderForm, "orderid2", $$v)},expression:"exchangeOrderForm.orderid2"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"warning","size":"mini"},on:{"click":function($event){return _vm.doExchangeOrder()}}},[_vm._v("交换数据")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.closeExchangeOrderDialog()}}},[_vm._v("取消交换")])],1)],1),_vm._v(" "),_c('order-allowance-dialog',{attrs:{"visible":_vm.dialogAllowanceVisible,"info":_vm.allowanceInfo},on:{"closeDialog":function($event){_vm.dialogAllowanceVisible=false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/order-review-table.e492edbad049cb7af7f5.js